import { ungzip } from "pako";

export const decodeEmailBody = (body_compressed: any, is_compressed: boolean = false) => {
  if (!body_compressed) return "";

  try {
    if(is_compressed) {
      const binaryString = atob(body_compressed);
      const byteArray = Uint8Array.from(binaryString, (char) =>
        char.charCodeAt(0)
      );

      const decompressed = ungzip(byteArray, { to: "string" });

      return decompressed;
    }
    return body_compressed
  } catch (error) {
    console.error("Decompression failed:", error);
    return "";
  }
}